var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllowVisio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 800",
    style: {
      enableBackground: "new 0 0 1280 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#5B7594;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 800
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "lower_object"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 642,
    className: "st1",
    width: 552.26,
    height: 47
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M810.26,694H258c-2.76,0-5-2.24-5-5v-47c0-2.76,2.24-5,5-5h552.26c2.76,0,5,2.24,5,5v47 C815.26,691.76,813.02,694,810.26,694z M263,684h542.26v-37H263V684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "655.93,641.81 361.67,641.81 326.59,476 620.85,476  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M655.93,646.81H361.67c-2.36,0-4.4-1.65-4.89-3.96L321.7,477.04c-0.31-1.48,0.06-3.01,1.01-4.18 c0.95-1.17,2.38-1.85,3.88-1.85h294.26c2.36,0,4.4,1.65,4.89,3.96l35.08,165.81c0.31,1.48-0.06,3.01-1.01,4.18 C658.86,646.13,657.43,646.81,655.93,646.81z M365.72,636.81h284.04L616.79,481H332.76L365.72,636.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "746.26,666 370.26,666 361.26,642 656.26,642  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M746.26,671h-376c-2.08,0-3.95-1.29-4.68-3.24l-9-24c-0.58-1.54-0.36-3.26,0.57-4.6 c0.93-1.35,2.47-2.15,4.11-2.15h295c0.44,0,0.87,0.06,1.29,0.17l90,24c2.43,0.65,4,2.99,3.67,5.48 C750.89,669.14,748.77,671,746.26,671z M373.72,661H708.1l-52.5-14H368.47L373.72,661z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M535.97,638.25h-137c-6.67-37.83,18.59-68.5,56.42-68.5S529.3,600.42,535.97,638.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M535.97,643.25h-137c-2.43,0-4.5-1.74-4.92-4.13c-3.52-19.98,1.07-38.76,12.93-52.89 c11.62-13.85,28.82-21.48,48.42-21.48c40.08,0,78.44,32.58,85.5,72.63c0.26,1.46-0.14,2.95-1.09,4.08 C538.85,642.6,537.45,643.25,535.97,643.25z M403.3,633.25h126.45c-8.75-32.75-40.87-58.5-74.35-58.5 c-16.6,0-31.07,6.36-40.76,17.91C405.52,603.52,401.56,617.81,403.3,633.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6753 -0.7375 0.7375 0.6753 -251.0873 506.6182)",
    className: "st2",
    cx: 449.89,
    cy: 538.5,
    rx: 40.75,
    ry: 48.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.73,588c-26.85,0-52.54-21.82-57.27-48.63c-2.38-13.5,0.74-26.21,8.78-35.79 c7.89-9.4,19.54-14.58,32.8-14.58c26.85,0,52.54,21.82,57.27,48.63c2.38,13.5-0.74,26.21-8.78,35.79 C482.64,582.82,470.99,588,457.73,588z M442.04,499c-10.25,0-19.18,3.91-25.14,11.01c-6.11,7.28-8.45,17.09-6.59,27.63 c3.92,22.26,25.2,40.37,47.42,40.37c10.25,0,19.18-3.91,25.14-11.01c6.11-7.28,8.45-17.09,6.59-27.63 C485.54,517.11,464.26,499,442.04,499z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "615.83,609 555.83,609 516.68,498 576.68,498  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M615.83,614h-60c-2.12,0-4.01-1.34-4.72-3.34l-39.14-111c-0.54-1.53-0.3-3.23,0.63-4.55 c0.94-1.32,2.46-2.11,4.08-2.11h60c2.12,0,4.01,1.34,4.72,3.34l39.14,111c0.54,1.53,0.3,3.23-0.63,4.55 C618.97,613.21,617.45,614,615.83,614z M559.37,604h49.4l-35.62-101h-49.4L559.37,604z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M566.26,523h-25c-2.76,0-5-2.24-5-5s2.24-5,5-5h25c2.76,0,5,2.24,5,5S569.02,523,566.26,523z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M573.51,545h-23c-2.76,0-5-2.24-5-5s2.24-5,5-5h23c2.76,0,5,2.24,5,5S576.27,545,573.51,545z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M580.26,564h-20c-2.76,0-5-2.24-5-5s2.24-5,5-5h20c2.76,0,5,2.24,5,5S583.02,564,580.26,564z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "342.04,457 382.04,457 386.97,485 346.97,485  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.97,490h-40c-2.43,0-4.5-1.74-4.92-4.13l-4.94-28c-0.26-1.46,0.14-2.95,1.09-4.08 c0.95-1.13,2.35-1.79,3.83-1.79h40c2.43,0,4.5,1.74,4.92,4.13l4.94,28c0.26,1.46-0.14,2.95-1.09,4.08 C389.86,489.35,388.45,490,386.97,490z M351.17,480h29.85l-3.17-18H348L351.17,480z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "394.92,461 331.92,461 318.09,423 381.09,423  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.92,466h-63c-2.1,0-3.98-1.31-4.7-3.29l-13.83-38c-0.56-1.53-0.33-3.24,0.6-4.58 c0.94-1.34,2.46-2.13,4.1-2.13h63c2.1,0,3.98,1.31,4.7,3.29l13.83,38c0.56,1.53,0.33,3.24-0.6,4.58 C398.08,465.2,396.55,466,394.92,466z M335.42,456h52.36l-10.19-28h-52.36L335.42,456z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.26,492.19c-17.59,0-34.33,0.1-49.53,1.86c-8.73-3.42-18.7-3.56-27.91,0.41l-136.48,59l-50.71-89.61 c-6.92-14.79-24.55-21.27-39.41-14.44c-7.23,3.32-12.72,9.26-15.48,16.72c-2.76,7.46-2.45,15.55,0.88,22.77l54.46,118.41 c0.5,2.44,1.25,4.86,2.27,7.23c3.92,9.1,11.14,16.14,20.35,19.81c4.45,1.77,9.1,2.66,13.74,2.66c4.88,0,9.75-0.98,14.38-2.92 l88.26-27.54c1.75,41.22,11.16,98.29,25.95,152.45h198.46c16.45-60.22,26.25-124.05,26.25-165.68 C1012.74,493.61,956.56,492.19,887.26,492.19z M886.58,482.49c47.77,0,86.5-38.73,86.5-86.5c0-47.77-38.73-86.5-86.5-86.5 s-86.5,38.73-86.5,86.5C800.08,443.76,838.81,482.49,886.58,482.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M887.26,492.19c-17.59,0-34.33,0.1-49.53,1.86c-8.73-3.42-18.7-3.56-27.91,0.41l-136.48,59l-50.71-89.61 c-6.92-14.79-24.55-21.27-39.41-14.44c-7.23,3.32-12.72,9.26-15.48,16.72c-2.76,7.46-2.45,15.55,0.88,22.77l54.46,118.41 c0.5,2.44,1.25,4.86,2.27,7.23c3.92,9.1,11.14,16.14,20.35,19.81c4.45,1.77,9.1,2.66,13.74,2.66c4.88,0,9.75-0.98,14.38-2.92 l88.26-27.54c1.75,41.22,11.16,98.29,25.95,152.45h198.46c16.45-60.22,26.25-124.05,26.25-165.68 C1012.74,493.61,956.56,492.19,887.26,492.19z M886.58,482.49c47.77,0,86.5-38.73,86.5-86.5c0-47.77-38.73-86.5-86.5-86.5 s-86.5,38.73-86.5,86.5C800.08,443.76,838.81,482.49,886.58,482.49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 710.5,
    y: 184.62,
    transform: "matrix(0.6636 -0.7481 0.7481 0.6636 40.5738 625.2305)",
    className: "st1",
    width: 10,
    height: 165.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661,
    y: 335.94,
    transform: "matrix(0.0411 -0.9992 0.9992 0.0411 229.9982 1057.6443)",
    className: "st1",
    width: 10,
    height: 146.12
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "upper_object"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllowVisio);
export default __webpack_public_path__ + "static/media/allow_visio.5474b6d32357eb59be7316e502197d35.svg";
export { ForwardRef as ReactComponent };